import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import { Images } from "../Common/Images";
import { ValidateRegisterConfirmation_api } from "./LoginAPI.js";

const ConformationRegister = () => {
    const { t } = useTranslation("common");
    const { uniqueCode = "" } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        const validateConfirmation = async () => {
            if (!uniqueCode) {
                setIsConfirmed(false);
                setMessage("Invalid confirmation link.");
                setIsLoading(false);
                return;
            }

            try {
                const response = await ValidateRegisterConfirmation_api(uniqueCode);
                const responseCode = Number(response?.Data?.ResponseCode ?? 0);
                const responseMessage =
                    response?.Data?.Message ||
                    response?.Data?.ErrorMessage ||
                    "";

                if (responseCode === 200) {
                    setIsConfirmed(true);
                    setMessage(response?.Data?.Message);
                } else if (responseCode === 400) {
                    setIsConfirmed(false);
                    setMessage(response?.Data?.ErrorMessage);
                } else {
                    setIsConfirmed(false);
                    setMessage(responseMessage || "Confirmation link is invalid or expired.");
                }
            } catch (error) {
                console.error("Error validating register confirmation:", error);
                setIsConfirmed(false);
                setMessage("Something went wrong while validating your confirmation link.");
            } finally {
                setIsLoading(false);
            }
        };

        validateConfirmation();
    }, [uniqueCode, t]);

    return (
        <div className="main-area">
            {isLoading && (
                <div id='preloader'>
                    <img src={Images.LoaderFull} alt="" />
                </div>
            )}
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 d-flex align-items-center justify-content-center vh-adjust">
                        <div className="green-box green-lightopacity">
                            <h1 className="fade-in-animation" style={{ display: 'block' }}>
                                {isConfirmed ? t("congratulations") : t("warning")}
                            </h1>
                            <img
                                src={isConfirmed ? Images.ThumbsUp : Images.AlertIcon}
                                alt=""
                                className="check-circle fade-in-animation"
                                style={{ display: 'block' }}
                            />
                            <div className="success-text fade-in-animation" style={{ display: 'block' }}>
                                <h3>
                                    {message}
                                    {/* {isConfirmed
                                        ? t("react_account_created_successfully")
                                        : t("user_not_register_something_went_wrong")} */}
                                </h3>
                                {/* <p className="verify-now">{message}</p> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConformationRegister;
